import { useEffect, useState } from "react";
import useCurrentUser from "../../hooks/useCurrentUser";
import { IFreelancer, RestrictedFreelancerRole } from "../../data_models/freelancer";

import FreelancerJobSuggestions from "./FreelancerJobSuggestions";
import useMyTasks from "../../hooks/useMyTasks";
import useProjectManagement from "../../hooks/useProjectManagement";
import FreelancerTasksTable from "./FreelancerTasksTable";
import { ITask } from "../../data_models/task";
import FreelancerDashboardOverview from "./FreelancerDashboardOverview";


const FreelancerDashboard = () => {

    const { currentUser } = useCurrentUser();

    const { tasksAsFreelancerInProgress } = useMyTasks();
    const { tasksAsPmUnassigned,
        tasksAsPmInProgress,
        tasksAsPmCompleted, } = useProjectManagement();

    const [pmTasks, setPmTasks] = useState<ITask[]>([])

    

    useEffect(() => {
        const tasks = [...tasksAsPmUnassigned, ...tasksAsPmInProgress, ...tasksAsPmCompleted];
        setPmTasks(tasks);
    }, [tasksAsPmUnassigned,
        tasksAsPmInProgress,
        tasksAsPmCompleted,])

    return (

        
        <div className="p-4 max-w-7xl mx-auto">
            <h3>Welcome {(currentUser as IFreelancer)?.firstName}</h3>

            <div className="mt-14">
                <FreelancerDashboardOverview />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-14">
                <div className="flex flex-col space-y-6">
                    <FreelancerTasksTable header="My Tasks" tasks={tasksAsFreelancerInProgress} />
                    {(currentUser as IFreelancer).restrictedRoles?.includes(RestrictedFreelancerRole.PROJECT_MANAGER)
                        && <FreelancerTasksTable header="PM Tasks" tasks={pmTasks} />}
                </div>
                <FreelancerJobSuggestions />
            </div>


        </div >
    );
};

export default FreelancerDashboard;